// Thin wrapper around jsonpath-plus so callers can keep the small
// `jsonpath.query(json, path)` surface of the deprecated `jsonpath` package.
//
// The upstream `jsonpath@1.1.x` package is unmaintained and carries two
// unfixed advisories (GHSA-6c59-mwgh-r2x6 prototype pollution, and
// GHSA-87r5-mp6g-5w5j arbitrary code injection via eval of JSONPath script
// expressions). See SVR-21046.
//
// `jsonpath-plus` is actively maintained. We pass `eval: 'safe'` so filter
// and script expressions are evaluated by the jsep-based safe evaluator
// rather than through `eval` / `Function`.
import { JSONPath } from 'jsonpath-plus';

const query = (json, path) => JSONPath({ path, json, eval: 'safe' });

export default { query };
export { query };
